export default function genererRegimeTva() {
  return {
    societeId: null,
    libelle: null,
    tauxTva: 0,
    compteCentralisationClient: null,
    compteCentralisationFournisseur: null,
    actif: true,
  };
}
